module.exports = __webpack_public_path__ + "static/media/origin.ceff9a2a.svg";